export const defaultTake = 20;